import { client } from '../utils'
import { orderAccessCodes as endpoints } from '../api_urls'

export const getCourses = () => {
  return async dispatch => {
    let url = endpoints.getCourses()
    try {
      var response = await client.get(url)
    } catch (err) {
      console.error(`Error fetching ${url}`, err)
      return
    }
    dispatch(updateCourses(response.data.courses))
  }
}

export const handleSubmit = () => {
  return async (dispatch, getState) => {
    let url = endpoints.handleForm()
    try {
      let {
        numberOfCodes,
        contactName,
        email,
        institution,
        ponumber,
        payNow,
        stripeToken,
        book,
        comments,
      } = getState()
      await client.post(url, {
        numberOfCodes,
        contactName,
        email,
        institution,
        ponumber,
        payNow,
        stripeToken,
        book,
        comments,
      })
    } catch (err) {
      if (err.response && err.response.status === 406) {
        dispatch(setFormError('Your credit card was declined.'))
      } else {
        console.error(`Error fetching ${url}`, err)
        dispatch(
          setFormError(
            'An unknown server error occurred. Contact support@myeducator.com'
          )
        )
      }
      dispatch(updateLoadingStatus(false))
      return
    }
    dispatch(updateFinishedStatus(true))
  }
}

export const updateCourses = courses => {
  return {
    type: 'UPDATE_COURSES',
    courses,
  }
}

export const updateBook = book => {
  return {
    type: 'UPDATE_BOOK',
    book,
  }
}

export const updateNumberOfCodes = numberOfCodes => {
  return {
    type: 'UPDATE_NUMBER_OF_CODES',
    numberOfCodes,
  }
}

export const updateContactName = contactName => {
  return {
    type: 'UPDATE_CONTACT_NAME',
    contactName,
  }
}

export const updateEmail = email => {
  return {
    type: 'UPDATE_EMAIL',
    email,
  }
}

export const updateInstitution = institution => {
  return {
    type: 'UPDATE_INSTITUTION',
    institution,
  }
}

export const updatePONumber = ponumber => {
  return {
    type: 'UPDATE_PO_NUMBER',
    ponumber,
  }
}

export const updatePayNow = payNow => {
  return {
    type: 'UPDATE_PAYNOW',
    payNow: payNow === 'true',
  }
}

export const updateComments = comments => {
  return {
    type: 'UPDATE_COMMENTS',
    comments,
  }
}

export const updateToken = stripeToken => {
  return {
    type: 'UPDATE_TOKEN',
    stripeToken,
  }
}

export const setFormError = formErrorMsg => {
  return {
    type: 'SET_ERROR_MSG',
    formErrorMsg,
  }
}

export const updateLoadingStatus = loading => {
  return {
    type: 'SET_LOADING_STATUS',
    loading,
  }
}

export const updateFinishedStatus = finished => {
  return {
    type: 'SET_FINISH_STATUS',
    finished,
  }
}
